<div class="invite-players-modal">
  <!-- Header -->

  <button class="close-button" (click)="closeModal()">
    <img src="assets/icons/icon-close.svg" alt="Close">
  </button>


  <!-- Main Content Wrapper -->
  <div class="invitep-wrap   align-items-stretch">
    <!-- Game Details Section -->
    <div class="invitep-main">
      <form [formGroup]="invitationForm" class="invitep-form">
        <h4>GAME DETAILS</h4>
        <ul>
          <li><span>Game Name:</span> <span>{{ game_details?.Gamename || 'FREE TEXT' }}</span></li>
          <li class="form-group">
            <span for="character-type">Game System:</span>
            <span>{{ invitationForm.get('gameSystem')?.value }}</span>
          </li>
          @if (invitationForm.get('gameSystem')?.touched && invitationForm.get('gameSystem')?.errors?.['required']) {
            <div
              class="text-danger">
              Field is required.
            </div>
          }
          <li><span>MAP:</span> <span>{{ game_details?.map_name || '%MAPNAME' }}</span></li>
        </ul>
      </form>
    </div>

    <!-- Player Invitation Section -->
    <div class="player-detail">
      <div class="player-detail-col">
        <div class="pd-col-left">Invite players (email)</div>
        <div class="pd-col-right">LEVEL</div>
      </div>
      <form [formGroup]="invitationForm">
        <div formArrayName="emailRows" class="email-row">
          @for (row of emailRows.controls; track row; let i = $index) {
            <ng-container [formGroupName]="i">
              <div class="pd-group">
                <div class="lbname">#{{ i + 1 }}:</div>
                <input type="email" formControlName="email" class="pemail" />
                <input type="number" formControlName="level" class="plevel" min="0" />
              </div>
              <div class="d-flex align-items-center  px-2">
                @if (row.get('email').dirty && row.get('email').errors) {
                  <div class="text-danger w-100">
                    @if (row.get('email').errors['email']) {
                      <div>
                        Invalid email format.
                      </div>
                    }
                    @if (row.get('email')?.errors['strictEmail']) {
                      <div>
                        Invalid email format (e.g. example&#64;domain.com).
                      </div>
                    }
                  </div>
                } @else {
                }
                @if (row.get('level')?.dirty && row.get('level')?.errors?.['min']) {
                  <div
                    class="text-danger right-0">
                    Level must be greater than 0.
                  </div>
                } @else {
                }
                @if (row.get('level')?.touched && row.get('level')?.errors?.['required']) {
                  <div
                    class="text-danger right-0">
                    Field is required.
                  </div>
                } @else {
                }
              </div>
            </ng-container>
          }
        </div>
      </form>
    </div>

    <!-- Token Upload and Action Buttons -->
    <div class="ai-token">
      <div class="ai-token-top" (click)="uploadPartyToken(game_details)">
        <h5>TOKEN</h5>
        <div class="image-container-token">
          <img [src]="partyToken || 'assets/images/ac-token-game.png'" alt="">
        </div>
        <input type="file" hidden>
        <div class="upload-section">
          <img src="assets/icons/icon-upload-outline.svg" alt="Upload">
          <span>Click to select</span>
        </div>
      </div>
      <div class="iv-btn-sec">
        <button type="submit" class="btn btn-green" (click)="sendEmail()" [disabled]="loading">
          {{ loading ? 'Sending...' : 'INVITE' }}
        </button>
        <button type="button" class="btn btn-theme" (click)="closeModal()">Cancel</button>
      </div>
    </div>
  </div>
</div>